<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — NEWS PAGE
     ════════════════════════════════════════════════ -->
<app-header-style-two></app-header-style-two>

<!-- Page Banner -->
<div class="page-title-area"
     [ngStyle]="{'background-image': 'url(' + createImgPath(getHeader_Img()) + ')'}">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li>{{"MENU.News" | translate}}</li>
        <li><a routerLink="/">{{"MENU.Home" | translate}}</a></li>
      </ul>
    </div>
  </div>
</div>

<!-- News Grid -->
<section class="blog-area">
  <div class="container">
    <div class="section-title" style="margin-bottom: 2.5rem;">
      <span class="sub-title">{{"MENU.News" | translate}}</span>
    </div>

    <div class="row">

      <!-- Loading skeleton -->
      <div class="col-lg-4 col-md-6" *ngIf="!isLoading">
        <app-content-loader></app-content-loader>
      </div>

      <!-- News cards -->
      <ng-container *ngIf="isLoading">
        <div *ngFor="let item of paginatedModels" class="col-lg-4 col-md-6" style="margin-bottom: 1.5rem;">
          <div class="vfu-card">
            <div class="vfu-card-img">
              <a [routerLink]="'/news-details/' + item.referenceId">
                <img [src]="createImgPath(item.img1)" alt="{{ item.title }}">
              </a>
            </div>

            <div class="vfu-card-body">
              <div class="vfu-card-meta">
                <i class='bx bx-calendar'></i>
                <span>{{ item.creationDate | date:'d MMMM y' }}</span>
              </div>

              <div class="vfu-card-title">
                <a [routerLink]="'/news-details/' + item.referenceId">{{ item.title }}</a>
              </div>

              <p class="vfu-card-excerpt">{{ item.shortText }}</p>

              <a [routerLink]="'/news-details/' + item.referenceId" class="vfu-read-more">
                {{"MENU.ReadMore" | translate}}
                <i class='bx bx-left-arrow-alt'></i>
              </a>
            </div>
          </div>
        </div>
      </ng-container>

    </div>

    <!-- Pagination -->
    <div class="pagination-area">
      <nav aria-label="التنقل بين الصفحات">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="isPreviousDisabled()" (click)="goToPreviousPage()">
            <a class="page-link" href="javascript:void(0)">
              <i class='bx bx-chevron-right'></i>
              {{"MENU.Previous" | translate}}
            </a>
          </li>

          <li *ngFor="let page of getPageNumbers()"
              class="page-item"
              [class.active]="isPageActive(page)">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
          </li>

          <li class="page-item" [class.disabled]="isNextDisabled()" (click)="goToNextPage()">
            <a class="page-link" href="javascript:void(0)">
              {{"MENU.Next" | translate}}
              <i class='bx bx-chevron-left'></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </div>
</section>

